import React from "react";
import { Link } from "react-router-dom";
import { HeartPulse, FileCheck2, ShieldCheck } from "lucide-react";
import SearchCard from "./SearchCard";
import { HERO_IMAGE, TRUST_AVATARS, POPULAR } from "../mock";

const BADGE_ICONS = { HeartPulse, FileCheck2, ShieldCheck };
const BADGES = [
  { icon: "HeartPulse", label: "First-aid / CPR trained" },
  { icon: "FileCheck2", label: "References checked" },
  { icon: "ShieldCheck", label: "Background check" },
];

export default function Hero() {
  return (
    <section className="hero-gradient">
      <div className="max-w-7xl mx-auto px-5 pt-12 pb-16 lg:pt-16 lg:pb-24 grid lg:grid-cols-2 gap-10 lg:gap-14 lg:items-stretch">
        {/* Left */}
        <div className="fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-3 py-1.5">
            <div className="flex -space-x-2">
              {TRUST_AVATARS.map((a, i) => (
                <img key={i} src={a} alt="family" className="w-6 h-6 rounded-full object-cover border-2 border-white" />
              ))}
            </div>
            <span className="text-[13px] text-[#5a5254] font-medium">Trusted by families across the US</span>
          </div>

          <h1 className="font-display text-[2.6rem] leading-[1.06] sm:text-6xl sm:leading-[1.05] text-[#1f1a1b] mt-5">
            Find a nanny, babysitter <span className="italic text-[#7c2233]">&</span> housekeeper in the US
          </h1>

          <p className="mt-5 text-[17px] leading-relaxed text-[#5a5254] max-w-xl">
            Post your job for free and connect with experienced, interviewed and background-checked candidates across the United States.
          </p>

          <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2">
            {BADGES.map((b) => {
              const Icon = BADGE_ICONS[b.icon];
              return (
                <div key={b.label} className="flex items-center gap-2 text-[14px] text-[#3a3436]">
                  <Icon className="w-4 h-4 text-[#7c2233]" strokeWidth={1.8} />
                  {b.label}
                </div>
              );
            })}
          </div>

          <div className="mt-6">
            <SearchCard />
          </div>

          <p className="mt-5 text-[13px] text-[#5a5254]">
            <span className="font-medium">Popular:</span>{" "}
            {POPULAR.map((p, i) => (
              <React.Fragment key={p.label}>
                <Link to={`/city/${p.slug}`} className="text-[#7c2233] hover:underline">{p.label}</Link>
                <span className="text-[#b8b0b2]"> · </span>
              </React.Fragment>
            ))}
            <Link to="/cities" className="text-[#7c2233] hover:underline">All cities</Link>
          </p>
        </div>

        {/* Right image */}
        <div className="fade-up hidden lg:block h-full" style={{ animationDelay: "0.15s" }}>
          <div className="relative h-full lg:pb-14">
            <img
              src={HERO_IMAGE}
              alt="Caregiver playing with children at home"
              className="w-full h-full min-h-[520px] object-cover rounded-[28px] shadow-[0_30px_70px_-25px_rgba(31,26,27,0.4)]"
            />
            <div className="absolute bottom-5 left-5 rounded-2xl bg-white/95 backdrop-blur px-4 py-3 shadow-lg">
              <div className="flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-[#7c2233]" />
                <div>
                  <p className="text-[13px] font-semibold text-[#1f1a1b] leading-tight">100% vetted care</p>
                  <p className="text-[11px] text-[#8a8285] leading-tight">Identity · Interview · References</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
